var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2891 6.71289L9.12275 3.54658L2.31463 10.3547L1.46958 13.1173C1.23519 13.8835 1.95212 14.6004 2.71835 14.3661L5.48095 13.521L12.2891 6.71289Z",
    fill: "#B2B8CC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4609 4.54011C14.8514 4.14959 14.8514 3.51643 14.4609 3.1259L12.7088 1.3738C12.3182 0.983276 11.6851 0.983276 11.2945 1.3738L10.0817 2.58668L13.248 5.75299L14.4609 4.54011Z",
    fill: "#B2B8CC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3008 5.70117L10.1345 2.53486L9.07903 3.5903L12.2453 6.75661L13.3008 5.70117Z",
    fill: "#F0F3F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEdit);
export default __webpack_public_path__ + "static/media/icon_edit.79360fa1e2fa61dd6e65766536600025.svg";
export { ForwardRef as ReactComponent };